import React from 'react';
import { useTranslation } from 'react-i18next';
import { CxoneConnectionProgress, CxoneConnectionStep } from '../../types';
import { getStepStatus } from '../../contexts/cxone/cxone-connection-steps';
import gateStyles from './AgentWidgetGate.module.css';

const STEP_MESSAGE_KEYS: Record<CxoneConnectionStep, string> = {
  ending_session: 'agent:loading.steps.endingSession',
  initializing_sdk: 'agent:loading.steps.initializingSdk',
  starting_session: 'agent:loading.steps.startingSession',
  connecting_voice: 'agent:loading.steps.connectingVoice',
};

interface AgentWidgetGateConnectingProps {
  connectionProgress: CxoneConnectionProgress | null;
}

export function AgentWidgetGateConnecting({ connectionProgress }: AgentWidgetGateConnectingProps) {
  const { t } = useTranslation();

  if (!connectionProgress) {
    return (
      <div className={gateStyles.loadingContainer}>
        <div className={gateStyles.spinner} />
        <p className={gateStyles.loadingText}>{t('agent:loading.connectingCxone')}</p>
      </div>
    );
  }

  return (
    <div className={gateStyles.loadingContainer}>
      <p className={gateStyles.loadingTitle}>{t('agent:loading.connectingCxone')}</p>
      <ol className={gateStyles.stepsList} aria-live="polite">
        {connectionProgress.steps.map((step) => {
          const status = getStepStatus(
            step,
            connectionProgress.steps,
            connectionProgress.activeStep
          );
          return (
            <li
              key={step}
              className={`${gateStyles.stepItem} ${gateStyles[`step${capitalize(status)}`]}`}
            >
              <span className={gateStyles.stepIndicator} aria-hidden="true">
                {status === 'done' ? (
                  <span className={gateStyles.stepCheck}>✓</span>
                ) : status === 'active' ? (
                  <span className={gateStyles.stepSpinner} />
                ) : (
                  <span className={gateStyles.stepPendingDot} />
                )}
              </span>
              <span className={gateStyles.stepLabel}>{t(STEP_MESSAGE_KEYS[step])}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
